import { useSelector } from "react-redux";
import { useMemo } from "react";

export default function useIsSpaceone(SelInverter) {
  const Iv_list = useSelector((state) => state.Iv_list || {});

  const isSpaceone = useMemo(() => {
    if (!Iv_list.seq || !Array.isArray(Iv_list.seq)) return false;
    const index = Iv_list.seq.findIndex((seq) => seq === SelInverter);
    if (index < 0) return false;

    const protocol = (Iv_list.iv_protocol?.[index] || "").toString().toLowerCase();
    return protocol.includes("spaceone");
  }, [Iv_list, SelInverter]);

  return isSpaceone;
}

